/**
 * Browser (website-restricted) Google Maps Platform key, the same key the
 * Maps JS script tag in index.html loads. Used for Static Maps images
 * rendered in the browser.
 */
export const GOOGLE_MAPS_BROWSER_API_KEY = 'AIzaSyC0BYBr_qDtlZPagRCFxO1kG5eufPAWaYo';
